module.exports = __webpack_public_path__ + "img/horizontal_3_3_r_pp3_3016.b9702b6e.png";